import React, { PureComponent } from 'react';
import classNames from 'classnames';

class URLInput extends PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.input.select();
  }

  render() {
    return (
      <input
        className={classNames('NewInput NewInput--fw NewInput--light', {
          [this.props.className]: this.props.className,
          'pr-0': true,
        })}
        onClick={this.handleClick}
        ref={n => {
          this.input = n;
        }}
        value={this.props.value}
        readOnly
      />
    );
  }
}

export default URLInput;
